import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

import { useCustomers } from '../hooks/useCustomers.ts';
import { useCustomersSelection } from '../hooks/useCustomersSelection.ts';
import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { Customer, CustomerStatus } from '../types';
import { ArchiveRecordButton } from '../buttons/ArchiveRecordButton.tsx';
import { CustomerStatusBadge } from '../profile/CustomerStatusBadge.tsx';

interface RecordsTableProps {
    statusFilter?: CustomerStatus | null;
}

export const RecordsTable = ({ statusFilter }: RecordsTableProps) => {
    const {selectedRecords, setSelectedRecords} = useCustomersSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useCustomers(statusFilter);



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<Customer>[] = [
        {
            accessor: 'name',
            title: 'Customer',
            render: (record: Customer) => (
                <Link to={`/customers/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.name}
                    </Text>
                </Link>
            )
        },
        { accessor: 'status', title: 'Status', render: (record: Customer) => (
            <CustomerStatusBadge status={record.status} />
        ) },
        { accessor: 'created', title: 'Created' },
        {
            accessor: 'actions',
            title: 'Actions',
            textAlign: 'center',
            render: (record: Customer) => (
                <ArchiveRecordButton customer={record} />
            )
        },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};